import { createContext } from 'react';
import { type EnqueuedCallback } from './types';

export const AnalyticsContext = createContext<
  | {
      enqueueEvent: (callback: EnqueuedCallback) => void;
    }
  | undefined
>(undefined);
